<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="card v-graph">
            <div class="card-body">
              <h3 class="card-title">
                <router-link :to="'/license/summary'">Statistik Pesan</router-link>
              </h3>
              <div id="bar-chart" style="width:auto !important"></div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 text-center" v-show="false">
          <div class="card v-graph">
            <div class="card-body">
              <h3 class="card-title">Sales Overview</h3>
              <div id="line-chart" style="width:auto !important"></div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from "vue";
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {},
  data() {
    return {
      paramSentMessagesAnnually: {
        year: "",
        provider: "whatsapp"
      }
    };
  },
  computed: {
    dataSentMessagesAnnually() {
      return this.$store.state.dashboard.dataSentMessagesAnnually;
    }
  },
  created() {},

  async mounted() {
    // await this.sentMessagesAnnually();

    await this.$store
      .dispatch(
        "dashboard/sentMessagesAnnually",
        this.paramSentMessagesAnnually
      )
      .then(response => {
        // console.log("resss", response);
        var { data } = response;
        let labels = data.labels;
        let ykeys = data.ykeys;
        let colors = data.colors;
        let dataRow = data.data;

        $(document).ready(function() {
          barChart(dataRow, ykeys, labels, colors, colors);
          // lineChart();

          $(window).resize(function() {
            window.barChart.redraw(dataRow, ykeys, labels, colors, colors);
          });
        });
      });

    function barChart(data, ykeys, labels, lineColors, barColors) {
      window.barChart = Morris.Bar({
        element: "bar-chart",
        data: data,
        xkey: "y",
        ykeys: ykeys,
        labels: labels,
        lineColors: lineColors,
        lineWidth: "3px",
        barColors: barColors,
        resize: true,
        redraw: true
      });
    }
    // function lineChart() {
    //   window.lineChart = Morris.Line({
    //     element: "line-chart",
    //     data: [
    //       { y: "2006", a: 50, b: 90 },
    //       { y: "2007", a: 75, b: 65 },
    //       { y: "2008", a: 50, b: 40 },
    //       { y: "2009", a: 75, b: 65 },
    //       { y: "2010", a: 50, b: 40 },
    //       { y: "2011", a: 75, b: 65 },
    //       { y: "2012", a: 100, b: 90 }
    //     ],
    //     xkey: "y",
    //     ykeys: ["a", "b"],
    //     labels: ["Total Sales", "Total Revenue"],
    //     lineColors: ["#ff9b44", "#fc6075"],
    //     lineWidth: "3px",
    //     resize: true,
    //     redraw: true
    //   });
    // }
  },
  methods: {},
  name: "index"
};
</Script>


// WEBPACK FOOTER //
// src/views/dashboard/components/graphSumLicense.vue